import { StrictMode } from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import App from './App.jsx';
import AuthProvider from './auth/AuthProvider.jsx';
import ErrorBoundary from './shared/ErrorBoundary.jsx';
import { createQueryClient } from './api/queryClient.js';
import './index.css';

const queryClient = createQueryClient();

const tree = (
  <StrictMode>
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <AuthProvider>
            <App />
          </AuthProvider>
        </BrowserRouter>
      </QueryClientProvider>
    </ErrorBoundary>
  </StrictMode>
);

const container = document.getElementById('root');

/*
 * Public routes ship as prerendered HTML (see scripts/prerender.js), so those
 * are hydrated rather than mounted fresh — rendering over them would throw the
 * static markup away and flash. Staff routes are not prerendered and mount
 * normally.
 */
if (container.hasChildNodes()) {
  hydrateRoot(container, tree);
} else {
  createRoot(container).render(tree);
}
